import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString } from '../../utils/API/requestMiddleware';

const logsAPI = createApi({
    baseQuery: defautBaseQuery, // Replace with your API endpoint
    reducerPath: 'logsAPI',
    endpoints: (builder) => ({
        getLogsById: builder.query({
            query: (data) => ({
                url: encryptQueryString(`/Logs/GetLogsById?dataKeyId=${data.dataKeyId}&KeyTypeName=${data.keyTypeName}&startDate=${data.startDate}&endDate=${data.endDate}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getActivityLogByModuleName: builder.query({
            query: (data) => ({
                url: encryptQueryString(`/Regulation/GetActivityLogByModuleName?moduleName=${data.moduleName}&recordId=${data.recordId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useLazyGetLogsByIdQuery,
    useLazyGetActivityLogByModuleNameQuery,
} = logsAPI;

export default logsAPI;